export default "__VITE_ASSET__CMnvQHyW__"